/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HomeownershipConsentChange } from './HomeownershipConsentChange';
import {
    HomeownershipConsentChangeFromJSON,
    HomeownershipConsentChangeFromJSONTyped,
    HomeownershipConsentChangeToJSON,
} from './HomeownershipConsentChange';
import type { HomeownershipConsentChannel } from './HomeownershipConsentChannel';
import {
    HomeownershipConsentChannelFromJSON,
    HomeownershipConsentChannelFromJSONTyped,
    HomeownershipConsentChannelToJSON,
} from './HomeownershipConsentChannel';

/**
 * One channel's consent state on the resident page: `granted` or `withdrawn`, and when it last changed.
 * @export
 * @interface HomeownershipConsentChannelBlock
 */
export interface HomeownershipConsentChannelBlock {
    /**
     * 
     * @type {HomeownershipConsentChannel}
     * @memberof HomeownershipConsentChannelBlock
     */
    channel: HomeownershipConsentChannel;
    /**
     * 
     * @type {HomeownershipConsentChange}
     * @memberof HomeownershipConsentChannelBlock
     */
    state: HomeownershipConsentChange;
    /**
     * 
     * @type {Date}
     * @memberof HomeownershipConsentChannelBlock
     */
    changedAt: Date;
}

/**
 * Check if a given object implements the HomeownershipConsentChannelBlock interface.
 */
export function instanceOfHomeownershipConsentChannelBlock(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "channel" in value;
    isInstance = isInstance && "state" in value;
    isInstance = isInstance && "changedAt" in value;

    return isInstance;
}

export function HomeownershipConsentChannelBlockFromJSON(json: any): HomeownershipConsentChannelBlock {
    return HomeownershipConsentChannelBlockFromJSONTyped(json, false);
}

export function HomeownershipConsentChannelBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeownershipConsentChannelBlock {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'channel': HomeownershipConsentChannelFromJSON(json['channel']),
        'state': HomeownershipConsentChangeFromJSON(json['state']),
        'changedAt': (new Date(json['changed_at'])),
    };
}

export function HomeownershipConsentChannelBlockToJSON(value?: HomeownershipConsentChannelBlock | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'channel': HomeownershipConsentChannelToJSON(value.channel),
        'state': HomeownershipConsentChangeToJSON(value.state),
        'changed_at': (value.changedAt.toISOString()),
    };
}

